import React from "react";

const PrivacyPolicy = () => {
    const privacypolicy = `Last updated on Jun 12th 2023

    Introduction
    CAMBRI ("we," "our," or "us") is committed to protecting your privacy and ensuring that your personal data is handled securely and transparently. This Privacy Policy outlines how we collect, use, and safeguard the information you provide when you use our website and services.

    By accessing or using the CAMBRI website, you consent to the practices described in this Privacy Policy. Please review it carefully.

    1. Information We Collect
    We may collect the following information when you use our website and services:

    Personal Identification Information: Name, job title, contact information (such as email address), etc.

    Demographic Information: Postcode, preferences, and interests.

    Other Information: Any additional information relevant to customer surveys, feedback, or offers.

    2. How We Use the Information
    The information we collect helps us improve our website, services, and user experience. Specifically, we may use your information for the following purposes:

    Internal record-keeping.

    To improve our products and services based on your feedback.

    To send promotional emails about new products, special offers, or other information that may be of interest to you.

    To conduct market research, including contacting you via email, phone, or mail for feedback.

    To customize our website according to your preferences.

    3. Data Security
    We are committed to ensuring that your personal information is secure. We have implemented appropriate security measures to prevent unauthorized access or disclosure.

    4. Cookies
    A cookie is a small file placed on your computer's hard drive that helps analyze web traffic and allows our website to respond to you as an individual. Cookies enable us to personalize the content of our site based on your preferences. We use cookies to monitor traffic on our website and improve its performance.

    How Cookies Help Us: Cookies allow us to analyze data about webpage traffic, helping us improve our website based on customer needs. The data collected is only used for statistical analysis and is then discarded.

    Your Control Over Cookies: You can choose to accept or decline cookies. Most browsers automatically accept cookies, but you can modify your settings to decline them if preferred. However, this may affect your ability to fully utilize the website's features.

    5. Controlling Your Personal Information
    You may restrict the collection or use of your personal information in the following ways:

    Look for the box to opt-out of direct marketing when filling out forms on our website.

    If you have previously agreed to receive promotional emails, you can opt out at any time by contacting us at service@cambri.ai.

    We will not sell, distribute, or lease your personal information to third parties without your consent, unless required by law. We may, however, share your information with trusted third parties to send you promotional materials that we think you may find useful, if you have given us permission to do so.

    6. Data Access and Corrections
    If you believe any information we hold about you is incorrect or incomplete, please contact us at the email address provided above. We will correct any information found to be inaccurate.

    7. Data Retention and Deletion
    We retain your personal information only for as long as necessary for the purposes outlined in this Privacy Policy. If you wish to delete your personal information, you may request data deletion by emailing support@cambri.ai. Once your request is processed and approved, we will promptly delete the relevant data.

    8. Third-Party Links
    Our website may contain links to other websites of interest. However, once you leave our site via these links, we do not have control over those external websites. Therefore, we cannot be responsible for the protection and privacy of any information you provide while visiting such sites. Please review the privacy policies of any third-party websites you visit.

    9. Changes to This Privacy Policy
    CAMBRI reserves the right to update or change this Privacy Policy at any time. Any changes will be posted on this page with an updated revision date. We encourage you to periodically review this Privacy Policy to stay informed about how we are protecting your information.

    10. Contact Us
    If you have any questions regarding this Privacy Policy or how we handle your personal information, please contact us at:

    Email: support@cambri.ai

    Website: https://ielts.web.cambri.ai/`;
  return (
    <div className="p-4 w-3/4 mx-auto">
      <h1 className="p-4 text-center text-4xl font-bold">CAMBRI</h1>
      <div className="bg-gray-100 p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold mb-4">Privacy Policy : </h2>
        <p className="whitespace-pre-line">{privacypolicy}</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
